/* global Blockly */
/* global Util */

// default/empty block used as a auto-generated response block
const CoreResponse = function(prop) {
    return {
        init: function() {
            this.appendDummyInput().appendField('', 'LABEL');
            this.setOutputShape(prop.shape);
            this.setColour(Blockly.Msg.CONNECTIONS_HUE);
            this.setOutput(true, prop.type);
        },
        mutationToDom: function() {
            let mutation = Util.dom('mutation', {
                label: this.getFieldValue('LABEL'),
                parent_id: this.parent_id
            });
            return mutation;
        },
        domToMutation: function(xml) {
            let label = (xml.getAttribute('label') || this.getFieldValue('LABEL'));
            this.setLabel(label);
            this.setParentId(xml.getAttribute('parent_id'));
        },
        setLabel: function(label) {
            this.getField('LABEL').setValue(label);
        },
        setParentId: function(id) {
            this.parent_id = id;
        },
        getJavascriptCore: function() {
            return `ResponseScope['${this.parent_id}']`;
        }
    }
}

export default CoreResponse;
